import {Redirect, Link} from 'react-router-dom'
import Cookies from 'js-cookie'
import Header from '../Header/Header' // Import Header
import './HomeRoute.css'

const HomeRoute = () => {
  const jwtToken = Cookies.get('jwt_token')

  // ✅ Fix: Ensure redirection works if jwtToken is empty or undefined
  if (!jwtToken) {
    return <Redirect to="/login" />
  }

  return (
    <div className="home-bg-container">
      {' '}
      {/* ✅ Wrap in a div for layout consistency */}
      <Header /> {/* Use Header component here */}
      <div className="home-container">
        <h1 className="heading-home">Find The Job That Fits Your Life</h1>
        <p className="description-home">
          Millions of people are searching for jobs, salary information,
          <br /> and company reviews. Find the job that fits your <br />
          abilities and potential.
        </p>

        <Link to="/jobs">
          <button
            type="button"
            data-testid="findJobs"
            className="find-jobs-btn"
          >
            Find Jobs
          </button>
        </Link>
      </div>
    </div>
  )
}

export default HomeRoute
